/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S6_Label_EtbisInputs */

const tr_iletisim_s6_label_etbis = /** @type {(inputs: Iletisim_S6_Label_EtbisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS Kayıt No`)
};

const en_iletisim_s6_label_etbis = /** @type {(inputs: Iletisim_S6_Label_EtbisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS registration no.`)
};

const de_iletisim_s6_label_etbis = /** @type {(inputs: Iletisim_S6_Label_EtbisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS-Registriernummer`)
};

const ru_iletisim_s6_label_etbis = /** @type {(inputs: Iletisim_S6_Label_EtbisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регистрационный номер ETBİS`)
};

/**
* | output |
* | --- |
* | "ETBİS registration no." |
*
* @param {Iletisim_S6_Label_EtbisInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s6_label_etbis = /** @type {((inputs?: Iletisim_S6_Label_EtbisInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S6_Label_EtbisInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s6_label_etbis(inputs)
	if (locale === "de") return de_iletisim_s6_label_etbis(inputs)
	if (locale === "ru") return ru_iletisim_s6_label_etbis(inputs)
	return tr_iletisim_s6_label_etbis(inputs)
});